"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("./config");
var BrowserCookies = require('js-cookie');
function getCookie(key) {
    if (config_1.getConfig().cookies) {
        return config_1.getConfig().cookies[key];
    }
    else {
        return BrowserCookies.get(key);
    }
}
exports.getCookie = getCookie;
function getCookieHeaderValue() {
    var cookies;
    if (!config_1.getConfig().cookies) {
        cookies = BrowserCookies.get();
    }
    else {
        cookies = config_1.getConfig().cookies;
    }
    if (cookies) {
        var keys = Object.keys(cookies);
        if (keys && keys.length > 0) {
            return keys.map(function (key) { return key + '=' + cookies[key]; }).join('; ');
        }
    }
    return null;
}
exports.getCookieHeaderValue = getCookieHeaderValue;
